import { render } from "./MetalValue.vue?vue&type=template&id=e4e48fcc&scoped=true"
import script from "./MetalValue.vue?vue&type=script&lang=js"
export * from "./MetalValue.vue?vue&type=script&lang=js"

import "./MetalValue.vue?vue&type=style&index=0&id=e4e48fcc&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e48fcc"]])

export default __exports__